import ContentLoader from 'react-content-loader';
import { useIsDarkMode } from '@/lib/hooks/use-is-dark-mode';
import { useIsMounted } from '@/lib/hooks/use-is-mounted';
import { atom, useAtom } from 'jotai';

const isLoadingAtom = atom(false);
export function useProductLoader() {
  const [isLoading, setIsLoading] = useAtom(isLoadingAtom);
  return {
    isLoading,
    setIsLoading,
  };
}

export default function ProductCardLoader(props: any) {
  // const isMounted = useIsMounted();
  const isMounted = true;
  const { isDarkMode } = useIsDarkMode();
  return (
    <ContentLoader
      speed={0}
      width={'100%'}
      height={'100%'}
      viewBox="0 0 500 500"
      backgroundColor={isMounted && isDarkMode ? '#27272A' : '#F4F4F5'}
      foregroundColor={isMounted && isDarkMode ? '#27272A' : '#F4F4F5'}
      {...props}
    >
      <rect x="0" y="450" rx="3" ry="3" width="40%" height="12" />
      <rect x="0" y="480" rx="3" ry="3" width="20%" height="10" />
      <rect x="0" y="0" rx="20" ry="20" width="100%" height="420" />
    </ContentLoader>
  );
}
